
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"レイヤー 2"}},[_c('g',{attrs:{"data-name":"レイヤー 1"}},[_c('path',{attrs:{"d":"M40 2a2 2 0 00-2-2H2a2 2 0 00-2 2v36a2 2 0 002 2h3a2 2 0 002-2V9a2 2 0 012-2h29a2 2 0 002-2zM75 40a2 2 0 00-2 2v29a2 2 0 01-2 2H42a2 2 0 00-2 2v3a2 2 0 002 2h36a2 2 0 002-2V42a2 2 0 00-2-2z"}}),_c('rect',{attrs:{"y":"36.5","width":"80","height":"7","rx":"2","transform":"rotate(-60 40 39.999)","data-name":"長方形 96"}})])])])
          )
        }
      }
    